import { createFileRoute } from "@tanstack/react-router";
import BreakupDepression from "@/pages/articles/BreakupDepression";
export const Route = createFileRoute("/when-a-breakup-doesnt-get-better")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "When A Breakup Doesnt Get Better | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "When a breakup doesn’t get better, depression may be the cause. Learn about TMS and treatment options for post-breakup depression in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "When A Breakup Doesnt Get Better | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "When a breakup doesn’t get better, depression may be the cause. Learn about TMS and treatment options for post-breakup depression in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/when-a-breakup-doesnt-get-better",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/when-a-breakup-doesnt-get-better",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BreakupDepression />;
}
